import { useMemo } from 'react';
import { evalWidths, computeAvailableFilters } from '../utils/sizingUtils';
import { useActiveReportStore } from 'hooks/useActiveReportStore';

export const useColumnWidths = (
  transformedData: any,
  filters: any,
  capabilities: any,
  budgetAvailable: boolean,
  audit: string
) => {
  const reportPayload = useActiveReportStore(state => state.reportPayload);
  const isVendorInvoicesReport = reportPayload?.templateId === 'Vendor Invoices';
  const shouldShowAuditAsBS = reportPayload?.type === 'Balance Sheet' && audit === 'true';

  return useMemo(() => {
    if (!transformedData) return null;
    // Use store values for multiLocation and consolidated
    const isMultiLocation = reportPayload?.multiLocation ?? false;
    const isConsolidated = reportPayload?.consolidated ?? false;
    return evalWidths(
      computeAvailableFilters(filters, capabilities, budgetAvailable),
      isMultiLocation && !isConsolidated,
      isVendorInvoicesReport || shouldShowAuditAsBS
    );
  }, [
    transformedData,
    filters,
    capabilities,
    budgetAvailable,
    isVendorInvoicesReport,
    shouldShowAuditAsBS,
    reportPayload,
  ]);
};
